export default __webpack_public_path__ + "static/media/1 (2).64a75113.jpg";